'use client';

import React from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { LotusIcon } from '@/components/ui/VedicIcons';
import MandalaBackground from '@/components/ui/MandalaBackground';

const NotFound = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center site-shell relative overflow-hidden p-4">
            <div className="absolute inset-0 pointer-events-none opacity-40">
                <MandalaBackground />
                <div className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] bg-[#D4AF37]/5 rounded-full blur-[120px]" />
                <div className="absolute bottom-[-20%] left-[-10%] w-[500px] h-[500px] bg-[#EA580C]/5 rounded-full blur-[100px]" />
            </div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
                className="text-center max-w-xl relative z-10 manuscript-shell manuscript-frame rounded-[2rem] px-8 py-12 md:px-12"
            >
                <motion.div
                    animate={{ y: [-8, 8, -8] }}
                    transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
                    className="flex justify-center mb-8"
                >
                    <div className="relative">
                        <div className="absolute inset-0 bg-[#D4AF37]/20 rounded-full blur-2xl scale-150" />
                        <LotusIcon size={64} className="text-[#D4AF37]/60 relative z-10" />
                    </div>
                </motion.div>

                <h1 className="text-8xl font-bold font-playfair text-transparent bg-clip-text bg-gradient-to-b from-[#f2dfb2] to-[#8d7446] mb-4 leading-none">
                    404
                </h1>
                <h2 className="text-2xl md:text-3xl font-playfair font-medium text-[#f7ead2] mb-3">
                    This Chapter Was Never Bound
                </h2>
                <p className="text-[#ddceb0]/68 mb-10 leading-relaxed">
                    The path you followed does not lead to a live page. Return to the main manuscript or retrace your previous step.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link
                        href="/"
                        className="inline-flex items-center justify-center gap-2 manuscript-button px-8 py-3.5 rounded-xl font-semibold"
                    >
                        <LotusIcon size={18} />
                        Return Home
                    </Link>

                    <button
                        onClick={() => typeof window !== 'undefined' && window.history?.back()}
                        className="inline-flex items-center justify-center gap-2 manuscript-button-secondary px-8 py-3.5 rounded-xl font-medium"
                    >
                        Retrace Your Steps
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export default NotFound;
